<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <div class="board_search_v2 board_search_wrap">
                            <div class="bo_sch_content">
                                <div class="sch_box">
                                    <div class="bo_sch_content">
                                        <span class="bo_sch_tit">기간</span>
                                        <DateRange :date="global.searchDate" @changeDate="(date) => global.setSearchDate(date)"></DateRange>
                                    </div>
                                    <div class="sch_btns">
                                        <button type="button" class="sch_btn" @click="getData()">검색하기</button>
                                        <button type="button" class="sch_re_btn" @click="resetFilter()">
                                            <img src="@/assets/board/re_btn.png" alt="" />
                                            초기화
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="board_top">
                            <div class="board_top_btns">
                                <button type="button" class="board_btn" @click="multiRemove()">선택 삭제</button>
                                <button type="button" class="board_btn" @click="openModal()">등록</button>
                                <div class="count">
                                    <p class="total_price">
                                        결제 금액 합($) :
                                        <span>{{ log.totalPrice.toLocaleString() }}</span>
                                    </p>
                                    <p class="total_count">
                                        결과 건수 합(건) :
                                        <span>{{ log.totalCount.toLocaleString() }}</span>
                                    </p>
                                </div>

                                <a href="https://developer.x.com/#pricing" target="_blank">X API 가격 정책</a>
                            </div>
                            <div class="board_top_btns">
                                <div class="count">
                                    총
                                    <span>{{ search.totalLength.toLocaleString() }}건</span>
                                </div>
                            </div>
                        </div>
                        <div class="board_list">
                            <table class="board_table">
                                <colgroup>
                                    <col width="3%" />
                                    <col width="5%" />
                                    <col width="5%" />
                                    <col width="10%" />
                                    <col width="10%" />
                                    <col width="" />
                                    <col width="15%" />
                                    <col width="10%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <label class="chk">
                                                <input type="checkbox" v-model="state.checkAll" @change="clickCheckAll()" />
                                                <span></span>
                                            </label>
                                        </th>
                                        <th>순번</th>
                                        <th>작성자</th>
                                        <th>결제금액($)</th>
                                        <th>결과건수(건)</th>
                                        <th>내용</th>
                                        <th>구매날짜</th>
                                        <th>구분</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!state.isLoading">
                                    <tr v-for="(item, idx) in log.list">
                                        <td>
                                            <label class="chk">
                                                <input type="checkbox" v-model="state.checkList" :value="item.idx" />
                                                <span></span>
                                            </label>
                                        </td>
                                        <td>
                                            {{
                                                search.currentPage === 1
                                                    ? numberFormat(idx + 1)
                                                    : numberFormat(search.perPage * (search.currentPage - 1) + idx + 1)
                                            }}
                                        </td>
                                        <td>{{ item.writer }}</td>
                                        <td class="">{{ item.price.toLocaleString() }}</td>
                                        <td class="">{{ item.count.toLocaleString() }}</td>
                                        <td class="text_left">
                                            <p
                                                :class="{ more_txt: item.content && item.content.length > 50 }"
                                                @click="moreText(item.content)"
                                            >
                                                {{ item.content }}
                                            </p>
                                        </td>
                                        <td>{{ formatDate(item.createDate) }}</td>
                                        <td>
                                            <div class="board_btns">
                                                <button type="button" class="blue_btn" @click="openModal(item.idx)">수정</button>
                                                <button type="button" class="gray_btn" @click="remove(item.idx)">삭제</button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="log.list.length === 0 && !state.isLoading">
                                    <tr>
                                        <td colspan="10">
                                            <NoResult :content="'검색된 목록이 없습니다.'"></NoResult>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="state.isLoading">
                                    <tr>
                                        <td colspan="10">
                                            <Spinner></Spinner>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <PageBtn
                            v-if="log.list.length !== 0 && !state.isLoading"
                            :currentPage="search.currentPage"
                            :totalLength="search.totalLength"
                            :perPage="search.perPage"
                            @onPaging="handlePageChange"
                        ></PageBtn>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ApiChargeModal v-if="modal.isShow" :isEdit="modal.isEdit" :info="modal.info" @close="closeModal"></ApiChargeModal>
    <Popup :show="popup.isShow" :title="popup.title" :content="popup.content" @close="closeModal"></Popup>
</template>
<script lang="ts" config>
    import {
        Header,
        Menu,
        apiService,
        onMounted,
        reactive,
        formatDate,
        PageBtn,
        globalStore,
        NoResult,
        Spinner,
        numberFormat,
        DateRange,
        Filter,
        dateFormat,
        watch,
        ApiChargeModal,
        Popup,
    } from "@/BaseComponent";
    import type { Data } from "@/services/api/xCharge";
    export default {
        props: {},
        components: {
            Header,
            Menu,
            PageBtn,
            NoResult,
            Spinner,
            DateRange,
            Filter,
            ApiChargeModal,
            Popup,
        },
        setup() {
            const global = globalStore();
            const state = reactive({
                isLoading: true as boolean,
                checkAll: false as boolean,
                checkList: [] as Array<number>,
            });

            const modal = reactive({
                isShow: false as boolean,
                info: {} as Data,
                isEdit: false as boolean,
            });

            const popup = reactive({
                isShow: false as boolean,
                title: "" as string,
                content: {
                    title: "" as string,
                    main: {
                        data: "" as string,
                        class: "desc",
                        render: (data: string) => {
                            return `<p class='pre_content'>${data}</p>`;
                        },
                    } as any,
                },
            });

            const log = reactive({
                list: [] as Array<Data>,
                totalPrice: 0 as number,
                totalCount: 0 as number,
            });

            const search = reactive({
                currentPage: 1 as number,
                totalLength: 0 as number,
                perPage: 100 as number,
                keyword: "" as string,
            });

            onMounted(() => {
                global.setSelectMenu(99);
                getData();
            });

            watch(
                () => state.checkList,
                () => {
                    if (state.checkList.length === log.list.length) {
                        state.checkAll = true;
                    } else {
                        state.checkAll = false;
                    }
                },
            );

            const getList = async () => {
                state.isLoading = true;
                const param = {
                    page: search.currentPage,
                    size: search.perPage,
                    startDate: dateFormat(new Date(global.searchDate[0])),
                    endDate: dateFormat(new Date(global.searchDate[1])),
                };
                const res = await apiService.xCharge.getList(param);
                if (res.returnCode === 0) {
                    log.list = res.list.data;
                    search.totalLength = res.list.recordsTotal;
                } else {
                    log.list = [];
                }
                state.isLoading = false;
            };

            const getStatus = async () => {
                const param = {
                    page: search.currentPage,
                    size: search.perPage,
                    startDate: dateFormat(new Date(global.searchDate[0])),
                    endDate: dateFormat(new Date(global.searchDate[1])),
                };
                const res = await apiService.xCharge.getStatus(param);
                if (res.returnCode === 0) {
                    log.totalPrice = res.price;
                    log.totalCount = res.count;
                }
            };

            const getDetail = async (idx: number) => {
                const res = await apiService.xCharge.getDetail(idx);
                if (res.returnCode === 0) {
                    modal.info = res.data;
                }
            };

            const getData = () => {
                getStatus();
                getList();
            };

            const resetFilter = () => {
                const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                const endDate = new Date();
                global.setSearchDate([startDate, endDate]);
                getData();
            };

            const multiRemove = async () => {
                if (state.checkList.length > 0) {
                    if (confirm("삭제하시겠습니까?")) {
                        const param = { idxList: state.checkList.join(",") };
                        const res = await apiService.xCharge.multiRemove(param);
                        if (res.returnCode === 0) {
                            alert("삭제 완료되었습니다.");
                            getList();
                            getStatus();
                        } else {
                            alert("삭제 실패했습니다.\n사유: " + res.description);
                        }
                    }
                } else {
                    alert("선택된 목록이 없습니다.");
                }
            };

            const remove = async (idx: number) => {
                if (confirm("삭제하시겠습니까?")) {
                    const res = await apiService.xCharge.remove(idx);
                    if (res.returnCode === 0) {
                        alert("삭제 완료되었습니다.");
                        getList();
                        getStatus();
                    } else {
                        alert("삭제 실패했습니다.\n사유: " + res.description);
                    }
                }
            };

            const closeModal = (data: { result: boolean; info: Data }) => {
                if (data.result) {
                    if (modal.isEdit) {
                        modify(data.info);
                    } else {
                        add(data.info);
                    }
                } else {
                    modal.isShow = false;
                    popup.isShow = false;
                    modal.info = {} as Data;
                }
            };

            const openModal = (idx: number | null = null) => {
                if (idx) {
                    getDetail(idx);
                    modal.isEdit = true;
                } else {
                    modal.isEdit = false;
                }
                modal.isShow = true;
            };

            const add = async (info: Data) => {
                const param = {
                    price: info.price,
                    count: info.count,
                    content: info.content,
                    createDate: info.createDate,
                };

                const res = await apiService.xCharge.add(param);
                if (res.returnCode === 0) {
                    alert("등록 완료되었습니다.");
                    getData();
                    modal.isShow = false;
                    modal.info = {} as Data;
                } else {
                    alert("등록 실패했습니다.\n사유 : " + res.description);
                }
            };

            const modify = async (info: Data) => {
                const param = {
                    price: info.price,
                    count: info.count,
                    content: info.content,
                    createDate: info.createDate,
                };
                const res = await apiService.xCharge.modify(info.idx, param);
                if (res.returnCode === 0) {
                    alert("수정 완료되었습니다.");
                    getData();
                    modal.isShow = false;
                    modal.info = {} as Data;
                } else {
                    alert("수정 실패했습니다.\n사유 : " + res.description);
                }
            };

            const clickCheckAll = () => {
                if (state.checkAll) {
                    state.checkList = log.list.map((item) => item.idx);
                } else {
                    state.checkList = [];
                }
            };

            const handlePageChange = (page: number) => {
                search.currentPage = page;
                getList();
            };

            const moreText = (content: string) => {
                if (content && content.length > 50) {
                    popup.title = "API충전 이력 내용";
                    popup.content.main.data = content;
                    popup.isShow = true;
                }
            };

            return {
                global,
                state,
                log,
                modal,
                popup,
                search,
                formatDate,
                numberFormat,
                getData,
                resetFilter,
                multiRemove,
                openModal,
                clickCheckAll,
                handlePageChange,
                remove,
                closeModal,
                moreText,
            };
        },
    };
</script>
<style scoped>
    .count p.total_price {
        margin-bottom: 5px;
    }
    .money::before {
        content: "$ ";
        float: left;
    }
    .sch_box {
        min-height: 45px;
    }
</style>
